import { useHttp } from "../http/useHttp";
import { paths } from "../generated-types";
import { useDefaultError } from "@synota-io/synota-shared-ui";
import { useAxiosMfaMutation } from "../http/useAxiosMfaMutation";

type ChangeFrozenStatusOperation =
  paths["/dashboard/synota/contracts/change-frozen-status"]["post"];
export type ChangeFrozenStatusInput =
  ChangeFrozenStatusOperation["requestBody"]["content"]["application/json"];

export const useFrozenStatusMutations = () => {
  const { client } = useHttp();

  const { isPending, status, data, error, mutate } = useAxiosMfaMutation<
    void,
    ChangeFrozenStatusInput
  >({
    mutationKey: ["change-frozen-status"],
    mutationFn: (input) => client.post("/synota/contracts/change-frozen-status", input),
  });

  useDefaultError(error, "Failed to change frozen status");

  return { changeFrozenStatus: mutate, isPending, status, data, error };
};

export type UseFrozenStatusMutationsReturn = ReturnType<typeof useFrozenStatusMutations>;
